import React from 'react';
import { Box, SimpleGrid, Skeleton, SkeletonText, Flex, Spacer, useBreakpointValue } from '@chakra-ui/react';

export interface TradingFloorSkeletonProps {
  rows?: number;
  showFilters?: boolean;
}

export default function TradingFloorSkeleton({ rows = 10, showFilters = true }: TradingFloorSkeletonProps) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const MOBILE_COLUMN_PX = 600;

  const renderSkeletonCard = () => (
    <Box
      minH="80px"
      w="100%"
      overflow="hidden"
      p={2}
      border="1px solid"
      borderColor="gray.300"
    >
      <Flex align="center">
        <Skeleton h="80px" w="80px" mr={4} />
        <Flex direction="column" flex="1" gap={2} pr={4}>
          <SkeletonText noOfLines={1} w="120px" />
          <SkeletonText noOfLines={1} w="80px" />
          <Flex align="center" gap={1}>
            <Skeleton h="15px" w="20px" />
            <SkeletonText noOfLines={1} w="60px" />
          </Flex>
          <Skeleton h="15px" w="40px" />
        </Flex>
        <Spacer />
        <Flex direction="column" gap={2} align="flex-end">
          <Skeleton h="20px" w="80px" />
          <SkeletonText noOfLines={1} w="60px" />
          <Skeleton h="15px" w="30px" />
        </Flex>
      </Flex>
    </Box>
  );

  const renderSkeletonSection = (color: string) => (
    <Flex direction="column" h="100%" borderRadius="md" overflow="hidden" bg="white">
      <Flex
        px={3}
        py={2}
        bg={`${color}.50`}
        border="1px solid"
        borderColor={`${color}.700`}
        borderRadius="md"
        h="42px"
        align="center"
				justify="center"
      >
        <SkeletonText noOfLines={1} w="80px" />
      </Flex>
      <Box flex="1" overflowY="auto" p={3}>
        <SimpleGrid columns={1} spacing={3}>
          {Array.from({ length: rows }).map((_, i) => (
            <Box key={i}>{renderSkeletonCard()}</Box>
          ))}
        </SimpleGrid>
      </Box>
    </Flex>
  );

  return (
    <Box>
      {showFilters && (
        <Flex direction="row" gap={4} mb={4} align="center">
          <Skeleton h="40px" w="250px" />
          <Spacer />
          <Flex gap={2}>
            <Skeleton h="32px" w="80px" />
            <Skeleton h="32px" w="80px" />
          </Flex>
        </Flex>
      )}

      <Flex
        direction={{ base: 'column', md: 'row' }}
        gap={6}
        maxH={{ base: 'auto', md: `${MOBILE_COLUMN_PX}px` }}
      >
        <Box flex={1} overflow="hidden">
          {renderSkeletonSection('blue')}
        </Box>
        <Box flex={1} overflow="hidden">
          {renderSkeletonSection('orange')}
        </Box>
      </Flex>
    </Box>
  );
}
